import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import FormHelpText from './form-helpText';
import { Markdown } from '@repo/ui/src/components/Markdown';
import type { LinkProps } from '@repo/ui/src/types/link';

interface FormCheckboxItem {
  title?: string;
  required?: boolean;
  link?: LinkProps;
  disclaimer?: string;
  validationMessage?: string;
  helpText?: string;
  unique?: string;
}

interface FormCheckboxProps {
  item: FormCheckboxItem;
  unique: string;
  submitted: boolean;
  Link?: (() => React.ReactElement | null) | null;
  preCheck?: boolean;
}

const FormCheckbox = ({ item, unique, submitted, Link = null, preCheck }: FormCheckboxProps) => {
  const [checked, setChecked] = useState(!!preCheck);
  return (
    <>
      <FormGroup className={submitted && item.required && !checked ? 'invalidInput' : ''}>
        <FormControlLabel
          className="cursor-auto"
          control={
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
              id={`form-${unique}`}
              name={`${unique}`}
              title={`${unique}`}
              required={item.required}
              aria-describedby={`${unique}-help`}
              aria-labelledby={`${unique}-help`}
            />
          }
          label={
            <span className="tra-text-web-body-l">
              {item.title}
              {item.link && Link ? ' ' : ''}
              {item.link && Link ? <Link /> : null}
            </span>
          }
        />
        {item?.disclaimer && <Markdown>{item.disclaimer}</Markdown>}
        <FormHelperText>{item.validationMessage}</FormHelperText>
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};

export default FormCheckbox;
